<template>
  <div>
    <template v-for="group in ['points', 'counts']">
      <div class="center-title center" :key="group"><h2 class="center">{{group|capitalise}}</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <ul>
            <li v-for="(val, key) in teamStats[item[0]][group]" :key="key">
              <span class="silent" v-if="item[0] == 'a'">{{key | capitalise}}: </span>
              <span class="min-30">{{val}}</span>
            </li>
          </ul>
        </div>
      </section>
    </template>

    <div class="center-title center"><h2 class="center">Player Stats</h2></div>
    <section class="fullwidth stats-table">
      <table>
        <!-- <col>
        <col>
        <colgroup span="3"></colgroup>
        <colgroup span="3"></colgroup>
        <colgroup span="4"></colgroup> -->
        <tr class="head">
          <th rowspan="2"></th>
          <th colspan="1"></th>
          <th colspan="3" scope="colgroup">Card</th>
          <th colspan="3" scope="colgroup">Raids</th>
          <th colspan="4" scope="colgroup">Tackle</th>
        </tr>
        <tr class="head second-row">
          <th scope="col">Pts</th>
          <th scope="col">G</th>
          <th scope="col">Y</th>
          <th scope="col">R</th>
          <th scope="col">R</th>
          <th scope="col">RB</th>
          <th scope="col">RT</th>
          <th scope="col">T</th>
          <th scope="col">TB</th>
          <th scope="col">TC</th>
          <th scope="col">TT</th>
        </tr>
        <template v-for="team in ['a', 'b']">
          <template v-for="role in roleOrder">
            <tr>
              <th class="subtitle" colspan="13">{{match.teams[team].name}} - {{role.name}}</th>
            </tr>
            <tr
              v-for="playerKey in match.teams[team].match.players"
              v-if="shouldShow(match.players[playerKey], role)"
              :key="playerKey">
              <th scope="row">{{match.players[playerKey].name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
              <td>{{match.players[playerKey].match.points.total}}</td>
              <td><span v-if="match.players[playerKey].match.green_card">✓</span><span v-else>✕</span></td>
              <td><span v-if="match.players[playerKey].match.yellow_card">✓</span><span v-else>✕</span></td>
              <td><span v-if="match.players[playerKey].match.red_card">✓</span><span v-else>✕</span></td>
              <td>{{match.players[playerKey].match.points.raid_points.touch}}</td>
              <td>{{match.players[playerKey].match.points.raid_points.bonus}}</td>
              <td>{{match.players[playerKey].match.points.raid_points.total}}</td>
              <td>{{match.players[playerKey].match.points.tackle_points.tackle}}</td>
              <td>{{match.players[playerKey].match.points.tackle_points.bonus}}</td>
              <td>{{match.players[playerKey].match.points.tackle_points.capture}}</td>
              <td>{{match.players[playerKey].match.points.tackle_points.total}}</td>
            </tr>
          </template>
        </template>
      </table>
    </section>

    <div class="center-title center"><h2 class="center">Player Counts</h2></div>
    <section class="fullwidth stats-table">
      <table>
        <!-- <col>
        <col>
        <colgroup span="1"></colgroup>
        <colgroup span="1"></colgroup> -->
        <tr class="head">
          <th rowspan="2"></th>
          <th colspan="5" scope="colgroup">Raid</th>
          <th colspan="4" scope="colgroup">Tackles</th>
        </tr>
        <tr class="head second-row">
          <th scope="col">E</th>
          <th scope="col">Sp</th>
          <th scope="col">S</th>
          <th scope="col">U</th>
          <th scope="col">T</th>
          <th scope="col">Sp</th>
          <th scope="col">S</th>
          <th scope="col">U</th>
          <th scope="col">T</th>
        </tr>
        <template v-for="team in ['a', 'b']">
          <template v-for="role in roleOrder">
            <tr>
              <th class="subtitle" colspan="12">{{match.teams[team].name}} - {{role.name}}</th>
            </tr>
            <tr
              v-for="playerKey in match.teams[team].match.players"
              v-if="shouldShow(match.players[playerKey], role)"
              :key="playerKey">
              <th scope="row">{{match.players[playerKey].name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
              <td>{{match.players[playerKey].match.raids.empty}}</td>
              <td>{{match.players[playerKey].match.raids.super_raids}}</td>
              <td>{{match.players[playerKey].match.raids.success}}</td>
              <td>{{match.players[playerKey].match.raids.unsuccess}}</td>
              <td>{{match.players[playerKey].match.raids.total}}</td>
              <td>{{match.players[playerKey].match.tackles.super_tackles}}</td>
              <td>{{match.players[playerKey].match.tackles.success}}</td>
              <td>{{match.players[playerKey].match.tackles.unsuccess}}</td>
              <td>{{match.players[playerKey].match.tackles.total}}</td>
            </tr>
          </template>
        </template>
      </table>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    match: Object
  },
  data () {
    return {
      roleOrder: [
        { keys: ['raider'], name: 'Raider' },
        { keys: ['all_rounder'], name: 'All Rounder' },
        { keys: ['defender_right_cover', 'defender_left_cover', 'defender_right_left_cover'], name: 'Cover' },
        { keys: ['defender', 'defender_left_corner', 'defender_right_corner'], name: 'Defender' },
        { keys: null, name: 'Others' }
      ]
    }
  },
  computed: {
    teamStats () {
      let stats = {}
      const teams = ['a', 'b']
      teams.forEach((team) => {
        const teamStats = this.match.teams[team].match.stats
        stats[team] = {}
        stats[team].counts = {}
        stats[team].points = {}

        let keys = ['all_outs', 'declare']
        keys.forEach((key) => {
          stats[team].counts[key] = teamStats[key]
        })

        Object.keys(teamStats.raids).forEach((key) => {
          stats[team].counts[`raids_${key}`] = teamStats.raids[key]
        })

        Object.keys(teamStats.tackles).forEach((key) => {
          stats[team].counts[`tackles_${key}`] = teamStats.tackles[key]
        })

        keys = ['all_out', 'declare', 'extras', 'total']
        keys.forEach((key) => {
          stats[team].points[key] = teamStats.points[key]
        })

        Object.keys(teamStats.points.raid_points).forEach((key) => {
          stats[team].points[`raids_${key}`] = teamStats.points.raid_points[key]
        })

        Object.keys(teamStats.points.tackle_points).forEach((key) => {
          stats[team].points[`tackles_${key}`] = teamStats.points.tackle_points[key]
        })
      })

      return stats
    }
  },
  methods: {
    shouldShow (player, for_role) {
      if ((player.match) && (player.match.played === true)) {
        const player_role = player.role
        if (for_role.keys == null) {
          let allRoles = []
          this.roleOrder.forEach((role) => {
            if (role.keys != null) {
              allRoles = allRoles.concat(role.keys)
            }
          })
          if (allRoles.indexOf(player_role) == -1) {
            return true
          }
        } else {
          if (for_role.keys.indexOf(player_role) > -1) {
            return true
          }
        }
      }

      return false
    }
  }
}
</script>
